function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconShareRexOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 16c0-1.378 1.121-2.5 2.5-2.5S10 14.622 10 16c0 1.379-1.121 2.5-2.5 2.5A2.502 2.502 0 015 16zm17 8.5c0-1.379 1.121-2.5 2.5-2.5s2.5 1.121 2.5 2.5-1.121 2.5-2.5 2.5a2.502 2.502 0 01-2.5-2.5zm0-17C22 6.122 23.121 5 24.5 5S27 6.122 27 7.5 25.879 10 24.5 10A2.503 2.503 0 0122 7.5zM3 16a4.5 4.5 0 004.5 4.5 4.472 4.472 0 003.312-1.476l9.273 4.636a4.472 4.472 0 00-.085.84 4.5 4.5 0 104.5-4.5 4.482 4.482 0 00-3.604 1.83l-9.103-4.552c.122-.407.207-.831.207-1.278 0-.447-.085-.871-.207-1.278l9.103-4.552A4.48 4.48 0 0024.5 12 4.5 4.5 0 1020 7.5c0 .288.033.567.085.839l-9.273 4.637A4.472 4.472 0 007.5 11.5 4.5 4.5 0 003 16z",
    fill: props.color
  }));
}

export default SvgIconShareRexOutline;